module.exports = __webpack_public_path__ + "img/Ball.da5dbd9f.png";